/** The four preset gridline colours from the handoff's colour row. */
export const SWATCHES = ['#f3f5fe', '#e7e5fe', '#9184d9', '#292b31'] as const;
